module.exports = __webpack_public_path__ + "img/magnifying-glass-dollar.b927924f.svg";